module.exports = __webpack_public_path__ + "static/media/logo.938b2e38.svg";